import styled from 'styled-components';

import MuiAccordion from '@mui/material/Accordion';

type Props = Readonly<{
  summaryClickable?: boolean;
}>;

const Accordion = styled(MuiAccordion).withConfig({
  shouldForwardProp: (prop) => prop !== 'summaryClickable',
})<Props>`
  &&& {
    background-color: transparent;
    box-shadow: none;

    > * > .Mui-focusVisible {
      background: transparent;
    }

    > * > .MuiAccordionSummary-root {
      cursor: ${({ summaryClickable = false }) => (summaryClickable ? 'pointer' : 'auto')};
      min-height: unset;
      padding: ${({ theme }) => theme.scTheme.space[0]};
    }

    > * > .MuiButtonBase-root {
      user-select: unset;
    }

    > * > .Mui-expanded,
    > * > .MuiAccordionSummary-root > .MuiAccordionSummary-content,
    .MuiAccordionDetails-root,
    &.MuiAccordion-root {
      margin: ${({ theme }) => theme.scTheme.space[0]};
      padding: ${({ theme }) => theme.scTheme.space[0]};
    }

    &.MuiAccordion-root::before {
      display: none;
    }

    .MuiCollapse-hidden {
      visibility: hidden;
    }
  }
`;

export default Accordion;
